import React, { useEffect, useState, useContext } from "react";
import { Context } from "../store/appContext";
import { confirmar } from "../utils/confirmar";
import EmptyState from "../components/EmptyState.jsx";
import { Button, Input, Modal, Alert, Spinner } from "../components/ui";

/* ── Iconos SVG ─────────────────────────────────────────────────── */
const ICONS = {
  clients: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>),
  plus:    (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>),
  edit:    (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>),
  trash:   (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>),
  car:     (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M5 17H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1l3-4h10l3 4h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2"/><circle cx="7.5" cy="17.5" r="2.5"/><circle cx="16.5" cy="17.5" r="2.5"/></svg>),
  search:  (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>),
};

const ClientesPage = () => {
  const { store, actions } = useContext(Context);
  const [showModal, setShowModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [busqueda, setBusqueda] = useState("");
  const [showCochesModal, setShowCochesModal] = useState(false);
  const [clienteCochesSeleccionado, setClienteCochesSeleccionado] = useState(null);
  const [deleteError, setDeleteError] = useState("");

  useEffect(() => {
    actions.getClientes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNuevo = () => {
    setEditando(null);
    setShowModal(true);
  };

  const handleEditar = (cliente) => {
    setEditando(cliente);
    setShowModal(true);
  };

  const handleEliminar = async (cliente) => {
    const nombre = cliente?.nombre || "este cliente";
    const confirmado = await confirmar(
      `Vas a eliminar a "${nombre}". Esta acción no se puede deshacer.`
    );
    if (!confirmado) return;

    try {
      await actions.eliminarCliente(cliente.id);
      actions.getClientes();
    } catch (err) {
      setDeleteError(err?.message || "No se pudo eliminar el cliente");
    }
  };

  const handleGestionarCoches = (cliente) => {
    setClienteCochesSeleccionado(cliente);
    setShowCochesModal(true);
  };

  const clientesFiltrados = (store.clientes || []).filter((c) =>
    c.nombre?.toLowerCase().includes(busqueda.toLowerCase()) ||
    c.telefono?.includes(busqueda) ||
    c.email?.toLowerCase().includes(busqueda.toLowerCase())
  );

  return (
    <div className="sw-ent-wrapper">
      {/* ── Hero ─────────────────────────────────────────────────── */}
      <div className="sw-veh-hero">
        <div className="sw-veh-hero-inner container">
          <div className="sw-veh-hero-body">
            <div className="sw-veh-hero-icon">
              <span style={{ width: 24, height: 24, display: "flex" }}>{ICONS.clients}</span>
            </div>
            <div style={{ flex: 1 }}>
              <p className="sw-home-eyebrow" style={{ marginBottom: "0.2rem" }}>Gestión</p>
              <h1 className="sw-veh-hero-title">Clientes</h1>
              <p className="sw-veh-hero-sub">Base de datos de clientes y sus vehículos asociados</p>
            </div>
            <Button variant="primary" icon={<span style={{ width: 16, height: 16, display: "inline-flex" }}>{ICONS.plus}</span>} onClick={handleNuevo}>
              Nuevo Cliente
            </Button>
          </div>
        </div>
      </div>

      <div className="container sw-ent-content">

        {deleteError && (
          <Alert variant="danger" onClose={() => setDeleteError("")}>
            {deleteError}
          </Alert>
        )}

        {/* ── Búsqueda ─────────────────────────────────────────── */}
        <div className="sw-ent-card">
          <div className="sw-ent-card-body" style={{ paddingTop: "1rem", paddingBottom: "1rem" }}>
            <div style={{ position: "relative" }}>
              <span style={{ position: "absolute", left: "0.85rem", top: "50%", transform: "translateY(-50%)", width: 16, height: 16, color: "var(--sw-muted)", display: "flex", pointerEvents: "none" }}>{ICONS.search}</span>
              <input
                type="text"
                className="form-control sw-pinput"
                style={{ paddingLeft: "2.5rem" }}
                placeholder="Buscar por nombre, teléfono o email…"
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* ── Tabla ────────────────────────────────────────────── */}
        <div className="sw-ent-table-card">
          <div className="sw-ent-table-header">
            <p className="sw-home-eyebrow" style={{ marginBottom: 0 }}>Directorio</p>
            <h3 className="sw-ent-table-title">
              {clientesFiltrados.length} cliente{clientesFiltrados.length !== 1 ? "s" : ""}
              {busqueda && ` — filtrado por "${busqueda}"`}
            </h3>
          </div>
          <div className="table-responsive">
            <table className="table mb-0 sw-ent-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>CIF/NIF</th>
                  <th>Teléfono</th>
                  <th>Email</th>
                  <th className="text-center">Coches</th>
                  <th>Dirección</th>
                  <th style={{ width: 96 }}></th>
                </tr>
              </thead>
              <tbody>
                {clientesFiltrados.map((c) => (
                  <tr key={c.id}>
                    <td style={{ fontWeight: 600, fontSize: "0.88rem" }}>{c.nombre}</td>
                    <td style={{ fontSize: "0.82rem", color: "var(--sw-muted)" }}>{c.cif || "-"}</td>
                    <td style={{ fontSize: "0.82rem" }}>{c.telefono || "-"}</td>
                    <td style={{ fontSize: "0.82rem", color: "var(--sw-muted)" }}>{c.email || "-"}</td>
                    <td className="text-center">
                      <span style={{
                        display: "inline-flex", alignItems: "center", justifyContent: "center",
                        width: 26, height: 26, borderRadius: 8, fontWeight: 700, fontSize: "0.8rem",
                        background: (c.total_coches ?? 0) > 0 ? "rgba(212,175,55,0.12)" : "var(--sw-surface-2)",
                        color: (c.total_coches ?? 0) > 0 ? "var(--sw-accent,#d4af37)" : "var(--sw-muted)",
                        border: "1px solid",
                        borderColor: (c.total_coches ?? 0) > 0 ? "rgba(212,175,55,0.3)" : "var(--sw-border)",
                      }}>{c.total_coches ?? 0}</span>
                    </td>
                    <td style={{ fontSize: "0.82rem", color: "var(--sw-muted)" }}>{c.direccion || "-"}</td>
                    <td>
                      <div style={{ display: "flex", gap: 4 }}>
                        <button className="sw-ent-icon-btn" title="Ver coches" onClick={() => handleGestionarCoches(c)}>
                          <span style={{ width: 14, height: 14, display: "flex" }}>{ICONS.car}</span>
                        </button>
                        <button className="sw-ent-icon-btn" title="Editar" onClick={() => handleEditar(c)}>
                          <span style={{ width: 14, height: 14, display: "flex" }}>{ICONS.edit}</span>
                        </button>
                        <button className="sw-ent-icon-btn sw-ent-icon-btn--danger" title="Eliminar" onClick={() => handleEliminar(c)}>
                          <span style={{ width: 14, height: 14, display: "flex" }}>{ICONS.trash}</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {clientesFiltrados.length === 0 && (
                  <EmptyState
                    colSpan={7}
                    title={busqueda ? "Sin resultados" : "Sin clientes"}
                    subtitle={busqueda ? `Ningún cliente coincide con "${busqueda}".` : "No hay clientes registrados. Añade el primero con Nuevo cliente."}
                  />
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {showModal && (
        <ClienteModal
          show={showModal}
          cliente={editando}
          onClose={() => { setShowModal(false); setEditando(null); }}
          onSaved={() => { actions.getClientes(); setShowModal(false); setEditando(null); }}
        />
      )}

      {showCochesModal && clienteCochesSeleccionado && (
        <CochesClienteModal
          show={showCochesModal}
          cliente={clienteCochesSeleccionado}
          onClose={() => { setShowCochesModal(false); setClienteCochesSeleccionado(null); }}
        />
      )}
    </div>
  );
};

const ClienteModal = ({ show, cliente, onClose, onSaved }) => {
  const { actions } = useContext(Context);
  const [form, setForm] = useState({
    nombre: "",
    cif: "",
    telefono: "",
    email: "",
    direccion: "",
    notas: "",
  });
  const [saving, setSaving] = useState(false);
  const [modalError, setModalError] = useState("");

  useEffect(() => {
    if (cliente) {
      setForm({
        nombre: cliente.nombre || "",
        cif: cliente.cif || "",
        telefono: cliente.telefono || "",
        email: cliente.email || "",
        direccion: cliente.direccion || "",
        notas: cliente.notas || "",
      });
    }
  }, [cliente]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (cliente) {
        await actions.actualizarCliente(cliente.id, form);
      } else {
        await actions.crearCliente(form);
      }
      onSaved();
    } catch (err) {
      setModalError(err?.message || "Error al guardar el cliente");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onClose={onClose} title={cliente ? "Editar Cliente" : "Nuevo Cliente"} size="md">
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          {modalError && (
            <Alert variant="danger" className="mb-3" onClose={() => setModalError("")}>
              {modalError}
            </Alert>
          )}
          {[
            { name: "nombre", label: "Nombre", required: true, type: "text", placeholder: "" },
            { name: "cif", label: "CIF/NIF", required: false, type: "text", placeholder: "B12345678" },
            { name: "telefono", label: "Teléfono", required: false, type: "text", placeholder: "" },
            { name: "email", label: "Email", required: false, type: "email", placeholder: "" },
            { name: "direccion", label: "Dirección", required: false, type: "text", placeholder: "" },
          ].map((f) => (
            <Input
              key={f.name}
              label={f.label}
              required={f.required}
              type={f.type}
              name={f.name}
              value={form[f.name]}
              onChange={handleChange}
              placeholder={f.placeholder}
            />
          ))}
          <div className="sw-ui-field">
            <label className="sw-plbl">Notas</label>
            <textarea className="form-control sw-pinput" name="notas" value={form.notas} onChange={handleChange} rows="3" />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" variant="outline" onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="primary" loading={saving}>
            {cliente ? "Guardar cambios" : "Crear cliente"}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

// ========== MODAL DE COCHES POR CLIENTE ==========
const CochesClienteModal = ({ show, cliente, onClose }) => {
  const { actions } = useContext(Context);
  const [coches, setCoches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFormModal, setShowFormModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [deleteError, setDeleteError] = useState("");

  useEffect(() => {
    if (show && cliente) {
      cargarCoches();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, cliente]);

  const cargarCoches = async () => {
    setLoading(true);
    try {
      const data = await actions.getCoches();
      const lista = (data || []).filter((c) => String(c.cliente_id) === String(cliente.id));
      setCoches(lista);
      actions.getClientes();
    } catch (err) {
      console.error("Error al cargar coches del cliente:", err);
      setCoches([]);
    } finally {
      setLoading(false);
    }
  };

  const handleNuevo = () => {
    setEditando(null);
    setShowFormModal(true);
  };

  const handleEditar = (coche) => {
    setEditando(coche);
    setShowFormModal(true);
  };

  const handleEliminar = async (cocheId) => {
    if (!await confirmar("¿Eliminar este coche?")) return;
    try {
      await actions.eliminarCoche(cocheId);
      await cargarCoches();
    } catch (err) {
      setDeleteError("Error al eliminar el coche");
    }
  };

  return (
    <Modal
      show={show}
      onClose={onClose}
      size="lg"
      title={
        <span style={{ display: "flex", alignItems: "center", gap: "0.65rem" }}>
          <span style={{ width: 18, height: 18, display: "flex", color: "var(--sw-accent,#d4af37)" }}>{ICONS.car}</span>
          Coches de {cliente.nombre}
        </span>
      }
    >
        <Modal.Body style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          {deleteError && (
            <Alert variant="danger" onClose={() => setDeleteError("")}>
              {deleteError}
            </Alert>
          )}
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button variant="primary" size="sm" icon={<span style={{ width: 14, height: 14, display: "inline-flex" }}>{ICONS.plus}</span>} onClick={handleNuevo}>
              Nuevo coche
            </Button>
          </div>

          {loading ? (
            <div style={{ textAlign: "center", padding: "2rem" }}>
              <Spinner />
            </div>
          ) : coches.length === 0 ? (
            <div style={{ padding: "1.5rem", borderRadius: 10, background: "var(--sw-surface-2)", border: "1px solid var(--sw-border)", color: "var(--sw-muted)", fontSize: "0.875rem", textAlign: "center" }}>
              Este cliente no tiene coches registrados.
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table mb-0 sw-ent-table">
                <thead>
                  <tr>
                    <th>Matrícula</th>
                    <th>Marca</th>
                    <th>Modelo</th>
                    <th>Color</th>
                    <th>Notas</th>
                    <th style={{ width: 72 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {coches.map((coche) => (
                    <tr key={coche.id}>
                      <td style={{ fontWeight: 700, color: "var(--sw-accent,#d4af37)" }}>{coche.matricula}</td>
                      <td style={{ fontSize: "0.85rem" }}>{coche.marca || "-"}</td>
                      <td style={{ fontSize: "0.85rem" }}>{coche.modelo || "-"}</td>
                      <td style={{ fontSize: "0.82rem", color: "var(--sw-muted)" }}>{coche.color || "-"}</td>
                      <td style={{ fontSize: "0.78rem", color: "var(--sw-muted)" }}>{coche.notas || "-"}</td>
                      <td>
                        <div style={{ display: "flex", gap: 4 }}>
                          <button className="sw-ent-icon-btn" title="Editar" onClick={() => handleEditar(coche)}>
                            <span style={{ width: 14, height: 14, display: "flex" }}>{ICONS.edit}</span>
                          </button>
                          <button className="sw-ent-icon-btn sw-ent-icon-btn--danger" title="Eliminar" onClick={() => handleEliminar(coche.id)}>
                            <span style={{ width: 14, height: 14, display: "flex" }}>{ICONS.trash}</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button type="button" variant="outline" onClick={onClose}>Cerrar</Button>
        </Modal.Footer>

      {showFormModal && (
        <FormCocheClienteModal
          show={showFormModal}
          cliente={cliente}
          coche={editando}
          onClose={() => { setShowFormModal(false); setEditando(null); }}
          onSaved={() => { setShowFormModal(false); setEditando(null); cargarCoches(); }}
        />
      )}
    </Modal>
  );
};

const FormCocheClienteModal = ({ show, cliente, coche, onClose, onSaved }) => {
  const { actions } = useContext(Context);
  const [modalError, setModalError] = useState("");
  const [form, setForm] = useState({
    matricula: "",
    marca: "",
    modelo: "",
    color: "",
    notas: "",
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (coche) {
      setForm({
        matricula: coche.matricula || "",
        marca: coche.marca || "",
        modelo: coche.modelo || "",
        color: coche.color || "",
        notas: coche.notas || "",
      });
    } else {
      setForm({
        matricula: "",
        marca: "",
        modelo: "",
        color: "",
        notas: "",
      });
    }
  }, [coche]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = {
        ...form,
        matricula: (form.matricula || "").toUpperCase().trim(),
        cliente_id: cliente.id,
      };

      if (coche) {
        await actions.actualizarCoche(coche.id, payload);
      } else {
        await actions.crearCoche(payload);
      }
      onSaved();
    } catch (err) {
      setModalError("Error al guardar el coche: " + err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onClose={onClose} title={coche ? "Editar coche" : `Nuevo coche — ${cliente.nombre}`} size="md">
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          {modalError && <Alert variant="danger">{modalError}</Alert>}
          {[
            { name: "matricula", label: "Matrícula", required: true, placeholder: "1234ABC" },
            { name: "marca", label: "Marca", required: false, placeholder: "" },
            { name: "modelo", label: "Modelo", required: false, placeholder: "" },
            { name: "color", label: "Color", required: false, placeholder: "" },
          ].map((f) => (
            <Input
              key={f.name}
              label={f.label}
              required={f.required}
              name={f.name}
              value={form[f.name]}
              onChange={handleChange}
              placeholder={f.placeholder}
            />
          ))}
          <div className="sw-ui-field">
            <label className="sw-plbl">Notas</label>
            <textarea className="form-control sw-pinput" name="notas" value={form.notas} onChange={handleChange} rows="3" />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" variant="outline" onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="primary" loading={saving}>
            {coche ? "Guardar cambios" : "Crear coche"}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default ClientesPage;
